"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Device Binding Service API definition
 * This is the REST API for the Device Binding Service (DBS).
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: convergent-dev@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error400LicensePlateCodeEnum = void 0;
exports.Error400LicensePlateCodeEnum = {
    ApigwError: 'APIGW_ERROR',
    DbsBadRequestParameters: 'DBS.BAD_REQUEST_PARAMETERS',
    DbsDeviceIsBound: 'DBS.DEVICE_IS_BOUND'
};
